import { defineWorld } from "@latticexyz/world";

export default defineWorld({
  namespace: "Tapticc",
  tables: {
    ToggleTable: {
      schema: {
        smartObjectId: "uint256",
        isSet: "bool"
      },
      key: ["smartObjectId"],
    },
    HeadHunters: {
      schema: {
        smartCharacterId: "address",
        points: "uint256",
        characterName: "string",
      },
      key: ["smartCharacterId"],
    },
  },
});
